const indexItems = [
  { id: 1, title: '动作猛片', count: '328 部', icon: 'ri-sword-line', color: 'primary' },
  { id: 2, title: '悬疑推理', count: '215 部', icon: 'ri-search-eye-line', color: 'accent' },
  { id: 3, title: '午夜专场', count: '186 部', icon: 'ri-moon-line', color: 'secondary' },
  { id: 4, title: '综艺爆笑', count: '402 期', icon: 'ri-emotion-laugh-line', color: 'primary' },
  { id: 5, title: '动漫番剧', count: '256 部', icon: 'ri-ghost-line', color: 'accent' },
  { id: 6, title: '经典港片', count: '173 部', icon: 'ri-film-line', color: 'secondary' },
  { id: 7, title: '热门合集', count: '89 个', icon: 'ri-fire-line', color: 'primary' },
  { id: 8, title: '新片速递', count: '每日更新', icon: 'ri-rocket-line', color: 'accent' },
  { id: 9, title: '高清修复', count: '142 部', icon: 'ri-hd-line', color: 'secondary' },
];

const colorMap: Record<string, string> = {
  primary: 'bg-primary-50 text-primary-600 group-hover:bg-primary-100',
  accent: 'bg-accent-50 text-accent-600 group-hover:bg-accent-100',
  secondary: 'bg-secondary-50 text-secondary-600 group-hover:bg-secondary-100',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">视频索引</h2>
        <p className="section-subtitle">按分类快速浏览，找到你喜欢的视频类型</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 mt-10">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-4 cursor-pointer hover:border-primary-200 transition-colors group text-center"
            >
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center mx-auto mb-3 transition-colors ${colorMap[item.color]}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-500 mt-1 block">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}